import { useTranslation } from "react-i18next";
import Step from "./step";

export interface IStepProgressProps {
  step: number;
  type?: number;
  steps: number[];
}

export default function ShopStepProgress({
  step,
  type,
  steps,
}: IStepProgressProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp" });
  return (
    <div className="w-full rtl text-center  m-auto pt-12 sm:!w-[70%]">
      <div className="flex">
        {type === 40 ? (
          <>
            <Step
              step={1}
              title={t("Select Line")}
              isActive={step > 0}
              steps={steps}
            />
            <Step
              step={2}
              title={t("Purchase Service")}
              steps={steps}
              isActive={step > 1}
            />
            <Step
              step={3}
              title={t("Enter Cell Number")}
              isActive={step > 2}
              steps={steps}
            />
            <Step
              step={4}
              title={t("Cell Number Confirmation")}
              isActive={step > 3}
              steps={steps}
            />
            <Step
              step={5}
              title={t("Payment")}
              isActive={step > 4}
              steps={steps}
              
            />
            <Step
              step={6}
              title={t("General Info")}
              isActive={step > 5}
              steps={steps}
            />
            <Step
              step={7}
              title={t("Upload NationalCartImage")}
              isActive={step > 6}
              steps={steps}
              lastStep
            />
          </>
        ) : (
          <>
            <Step
              step={1}
              title={t("Purchase Service")}
              steps={steps}
              isActive={step > 0}
            />
            <Step
              step={2}
              title={t("Enter Cell Number")}
              isActive={step > 1}
              steps={steps}
            />
            <Step
              step={3}
              title={t("Cell Number Confirmation")}
              isActive={step > 2}
              steps={steps}
            />
            <Step
              step={4}
              title={t("Payment")}
              isActive={step > 3}
              steps={steps}
            />
            <Step
              step={5}
              title={t("General Info")}
              isActive={step > 4}
              steps={steps}
            />
            <Step
              step={6}
              title={t("Upload NationalCartImage")}
              isActive={step > 5}
              steps={steps}
              lastStep
            />
          </>
        )}
      </div>
    </div>
  );
}
